import { ServerSideRowModelModule } from "ag-grid-enterprise";
import { ModuleRegistry } from '@ag-grid-community/core';
import { observer } from "mobx-react";
import useStore from "../../../../store";
import { ServerGridConfig } from "../../../../config/GridConfig";
import { AgGridReact } from 'ag-grid-react';
import Message from '../../../../config/Message';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const ListComponent = observer(() => {
	ModuleRegistry.registerModules([ServerSideRowModelModule]);
	dayjs.extend(utc);
	dayjs.extend(timezone);

	const { PLATFORMBOOKING } = useStore();

	const colDefs = [
		{
			headerName: 'Property Name',
			field: 'propertyName',
			minWidth: 175,
			sortable: true
		},
		{
			headerName: 'Name',
			field: 'name',
			minWidth: 150,
			sortable: true
		},
		{
			headerName: 'Mobile No',
			field: 'mobileNo',
			minWidth: 150,
			sortable: true
		},
		{
			headerName: 'Check In/Out',
			field: 'checkInDate',
			minWidth: 160,
			sortable: true,
			sort: 'desc',
			valueFormatter: ({ data }) => {
				const checkIn = data.checkInDate ? dayjs.utc(data.checkInDate).tz('Asia/Kolkata').format('DD/MM/YY') : '';
				const checkOut = data.checkOutDate ? dayjs.utc(data.checkOutDate).tz('Asia/Kolkata').format('DD/MM/YY') : '';
				return checkIn && checkOut ? `${checkIn} - ${checkOut}` : checkIn || checkOut || '';
			},
		},
		{
			headerName: 'No. of Room',
			field: 'noOfRoom',
			minWidth: 150,
			sortable: true
		},
		{
			headerName: 'No. of Guest',
			field: 'noOfGuest',
			minWidth: 150,
			sortable: true
		},
		{
			headerName: 'Booking No',
			field: 'bookingNo',
			minWidth: 175,
			sortable: true
		},
	];

	return (
		<div
			className="ag-theme-quartz"
			style={{ height: 'calc(100vh - 220px)' }}
		>
			<AgGridReact
				onGridReady={PLATFORMBOOKING.setupGrid}
				headerHeight={35}
				columnDefs={colDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={Message().noRecord}
				gridOptions={ServerGridConfig.options}
			/>
		</div>
	);
});

export default ListComponent;
